/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import { VappRequestProcessor } from "../StateMachineService";
import { CollectionListMessage, PageContentMessage } from "./messages";
import { GET_PAGE_CONTENT_CONFIG } from "./machines/GetPageContent";
import { GET_COLLECTION_LIST_CONFIG } from "./machines/GetCollectionList";

const is = require("is_js");

const SERVICE_NAME = "CertificateForReviewPageService";
const log: any = LoggerModule.getInstance();

export class CertificateForReviewPageService extends VappRequestProcessor {
  private static instance: CertificateForReviewPageService;
  private vapp: VApplication;
  private loginRestAPI: string;
  private headers: any;
  private criteria: any;

  private constructor(props: any = {}) {
    super();
    this.vapp = VApplication.getInstance();
    this.loginRestAPI = props?.loginRestAPI;
    this.headers = props?.headers;
  }

  public static getInstance(props: any = {}): CertificateForReviewPageService {
    if (!CertificateForReviewPageService.instance) {
      CertificateForReviewPageService.instance = new CertificateForReviewPageService(props);
    }
    return CertificateForReviewPageService.instance;
  }

  private setCriteria(data: any) {
    this.criteria = data;
  }

  public resetCriteria() {
    this.criteria = null;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }
  
  public async getPageContent(args: any) {
    try {
      const machineType = "GET_COLLECTION_PAGE_CONTENT";
      const managers = this.getManagers(machineType);
      const input = new PageContentMessage({
        offset: args.offset,
        size: args.size,
      });
      await this.startProcessing({
        machineType: machineType,
        machineConfig: GET_PAGE_CONTENT_CONFIG?.extendContextWith({
          input: input,
          managers: managers,
        }),
      });
      return input;
    } catch (e: any) {
      log.error(`Error in getPageContent =>`, e);
      throw e;
    }
  }

  public async getCollectionList(args: any) {
    try {
      const machineType = "GET_COLLECTION_LIST";
      const managers = this.getManagers(machineType);
      const input = new CollectionListMessage({
        offset: args.offset,
        size: args.size,
      });
      await this.startProcessing({
        machineType: machineType,
        machineConfig: GET_COLLECTION_LIST_CONFIG?.extendContextWith({
          input: input,
          managers: managers,
        }),
      });
      return input;
    } catch (e: any) {
      log.error(`Error in getPageContent =>`, e);
      throw e;
    }
  }

  private getManagers(machineType: string) {
    switch (machineType) {
      case "GET_COLLECTION_PAGE_CONTENT":
        return {};
      case "GET_COLLECTION_LIST":
        return {};
      default:
        throw new Error(`machine type ${machineType} not supported.`);
    }
  }
}
